import { env } from '@/lib/env';

export interface PexelsPhoto {
    id: number;
    width: number;
    height: number;
    photographer: string;
    photographer_url: string;
    alt: string;
    src: {
        original: string;
        large2x: string;
        large: string;
        medium: string;
        small: string;
        portrait: string;
        landscape: string;
        tiny: string;
    };
}

interface PexelsSearchResponse {
    total_results: number;
    page: number;
    per_page: number;
    photos: PexelsPhoto[];
    next_page?: string;
}

export const pexelsService = {
    search: async (query: string, page: number = 1, perPage: number = 15): Promise<PexelsSearchResponse> => {
        const apiKey = env.PEXELS_API;
        if (!apiKey) {
            throw new Error('Pexels API key is not configured');
        }

        const params = new URLSearchParams({
            query,
            page: String(page),
            per_page: String(perPage),
        });

        const response = await fetch(`https://api.pexels.com/v1/search?${params}`, {
            headers: { Authorization: apiKey },
        });

        if (!response.ok) {
            throw new Error(`Pexels API error: ${response.status}`);
        }

        return response.json();
    },

    downloadAsFile: async (photo: PexelsPhoto): Promise<File> => {
        const response = await fetch(photo.src.large);
        const blob = await response.blob();
        const extension = blob.type.includes('png') ? 'png' : 'jpg';
        return new File([blob], `pexels-${photo.id}.${extension}`, {
            type: blob.type,
            lastModified: Date.now(),
        });
    },
};
